import { motion } from "framer-motion";
import { Star, Check, X, Trash2, Loader2 } from "lucide-react";

const badge = {
  pending: "bg-hazard/20 text-hazard border-hazard/40",
  approved: "bg-green-500/20 text-green-300 border-green-500/40",
  rejected: "bg-red-500/20 text-red-300 border-red-500/40",
};

export const ReviewsAdmin = ({ reviews, loading, onAction, onDelete }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="animate-spin text-hazard" size={28} />
      </div>
    );
  }
  if (reviews.length === 0) {
    return (
      <div data-testid="no-admin-reviews" className="border border-surface-2 py-20 text-center text-zinc-500 font-mono text-sm tracking-wide uppercase">
        No reviews submitted yet
      </div>
    );
  }
  return (
    <div className="space-y-px bg-surface-2 border border-surface-2">
      {reviews.map((r, i) => (
        <motion.div
          key={r.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.03 }}
          data-testid={`admin-review-${r.id}`}
          className="bg-ink p-5 md:p-6 grid md:grid-cols-[1fr_auto] gap-4 md:items-center"
        >
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div className="font-display text-2xl tracking-wide">{r.name}</div>
              <div className="flex">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star
                    key={n}
                    size={14}
                    className={r.rating >= n ? "fill-hazard text-hazard" : "text-surface-2"}
                  />
                ))}
              </div>
              <span className={`px-2 py-0.5 border text-[10px] tracking-wider uppercase font-mono ${badge[r.status] || ""}`}>
                {r.status}
              </span>
            </div>
            {r.service && (
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-hazard mb-2">
                {r.service}
              </div>
            )}
            <p className="text-zinc-300 text-sm md:text-base">"{r.comment}"</p>
          </div>
          <div className="flex md:flex-col gap-2">
            {r.status !== "approved" && (
              <button
                onClick={() => onAction(r.id, "approved")}
                data-testid={`approve-review-${r.id}`}
                className="flex items-center gap-2 border border-green-500/40 text-green-300 px-4 py-2 font-mono text-xs tracking-[0.15em] uppercase hover:bg-green-500/10 transition-colors"
              >
                <Check size={14} /> Approve
              </button>
            )}
            {r.status !== "rejected" && (
              <button
                onClick={() => onAction(r.id, "rejected")}
                data-testid={`reject-review-${r.id}`}
                className="flex items-center gap-2 border border-surface-2 text-zinc-400 px-4 py-2 font-mono text-xs tracking-[0.15em] uppercase hover:text-red-300 hover:border-red-400/40 transition-colors"
              >
                <X size={14} /> Reject
              </button>
            )}
            <button
              onClick={() => onDelete(r.id)}
              data-testid={`delete-review-${r.id}`}
              className="flex items-center justify-center border border-surface-2 text-zinc-500 px-4 py-2 hover:text-red-400 hover:border-red-400/50 transition-colors"
              aria-label="Delete review"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
